import React from 'react';
import { Router, Redirect, Switch, Route } from "react-router-dom";
import Menu from './Menu';
import Juzgados from './juzgados/Main';
import Defensorias from './defensorias/Main';
import Areas from './areas/Main';
import Usuarios from './usuarios/Main';
import Materias from './materias/Main';

class Main extends React.Component {
  constructor(props) {
    super(props);
    this.state={}
  }

  render(){
    return(
      <Router history={this.props.history}>
        <div className="Todo Configuraciones">
          <h2>Configuraciones</h2>
          <Menu history={this.props.history}/>
          <Switch>
            <Route
              path="/configuraciones/materias"
              component={(props) =>
                <Materias />
              }
            />
            <Route
              path="/configuraciones/juzgados"
              component={(props) =>
                <Juzgados />
              }
            />
            <Route
              path="/configuraciones/defensorias"
              component={(props) =>
                <Defensorias />
              }
            />
            <Route
              path="/configuraciones/areas"
              component={(props) =>
                <Areas />
              }
            />
            <Route
              path="/configuraciones/usuarios"
              component={(props) =>
                <Usuarios />
              }
            />
            <Route exact path="/configuraciones">
              <Redirect to="/configuraciones/juzgados" />
            </Route>
            <Route path="/configuraciones/*">
              <Redirect to="/configuraciones/juzgados" />
            </Route>
          </Switch>
        </div>
      </Router>
    );
  }
}

export default Main;
